import {
  getBulkRowTuples,
  isBulkRetryableStatus,
  isBulkSettlementTerminalStatus,
  projectBulkStatusEvent,
} from "./bulkUploadProjection";

export const isViewImagesKnownStatus = (status) =>
  isBulkRetryableStatus(status) || isBulkSettlementTerminalStatus(status);

export const getViewImagesRowTuples = (row, orgId) => {
  if (
    !row ||
    row.mrn !== null ||
    !Number.isSafeInteger(orgId) ||
    Number(row.orgz_id) !== orgId
  ) {
    return [];
  }
  return getBulkRowTuples(row);
};

export const isViewImagesKnownRow = (row, orgId) =>
  Array.isArray(row?.status) &&
  row.status.length > 0 &&
  getViewImagesRowTuples(row, orgId).length === row.status.length &&
  row.status.every((item) => isViewImagesKnownStatus(item?.status));

export const getViewImagesRetryableRows = (rows = [], orgId) =>
  Array.isArray(rows)
    ? rows.flatMap((row) => {
        if (!isViewImagesKnownRow(row, orgId)) return [];
        const status = row.status.filter((item) =>
          isBulkRetryableStatus(item?.status)
        );
        return status.length > 0 ? [{ ...row, status }] : [];
      })
    : [];

export const projectViewImagesStatusEvent = (
  rows = [],
  event = {},
  { orgId } = {}
) => {
  if (!Array.isArray(rows)) return { outcome: "ignored", rows };
  if (!isViewImagesKnownStatus(event?.status)) {
    return { outcome: "ignored", rows };
  }
  const eligibleIndexes = [];
  const eligibleRows = [];
  rows.forEach((row, index) => {
    if (!isViewImagesKnownRow(row, orgId)) return;
    eligibleIndexes.push(index);
    eligibleRows.push(row);
  });
  const result = projectBulkStatusEvent(eligibleRows, event);
  if (result.outcome !== "applied") return { outcome: result.outcome, rows };

  const nextRows = rows.map((row) => row);
  result.rows.forEach((row, index) => {
    nextRows[eligibleIndexes[index]] = row;
  });
  return { outcome: "applied", row: result.row, rows: nextRows };
};
